module.exports = "/_next/static/images/448f866e1a1662e3444e3907a528c6cb-man-looking-up-smiling-xs@2x.jpg";